import { render, staticRenderFns } from "./charges.vue?vue&type=template&id=cf46803a&"
import script from "./charges.vue?vue&type=script&lang=js&"
export * from "./charges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports